<template>
  <div class="main">
    <div class="top_native">
      <template v-for="item in bannerList">
        <img class="bannerImg" :src="item.imgUrl" alt="">
        <div class="caseTitle animate__animated animate__zoomIn">
          <div class="chinese" v-html="item.titleMain"></div>
          <div class="engli" v-html="item.titleAssistant"></div>
        </div>
      </template>
      <div class="map">
        <EchartsMap ref="EchartsMap"></EchartsMap>
        <EditMap v-if="$store.state.editStatus === 0" @onClose="onCloseMap" />
      </div>
      <Banner v-if="$store.state.editStatus === 0" :type="3" :list="bannerList" @onReturn="bannerDate" />
    </div>
    <div class="mainCon" id="searchBar">
      <div class="navBar">
        <div class="nav_arr">
          <div class="menuItem" v-for="(itemNav, index) in nav_list" :key="index" @click="onNavList(index, itemNav)"
            :class="active_index == index ? 'active' : ''">
            <span>{{ itemNav }}</span>
          </div>
        </div>
        <div class="search">
          <SearchCase @searchData="searchData"></SearchCase>
        </div>
      </div>
      <div class="cards">
        <template v-for="(item, index) in showlist">
          <div class="card">
            <div class="topTit" v-if="index % 2 === 0">
              <div class="name" @click="pdfUrl(item)">
                {{ item.title }}
              </div>
              <!-- <div class="kind" v-for="label in item.label">{{ label }}</div> -->
            </div>
            <div class="topTit flexRight" v-else>
              <!-- <div class="kind" v-for="label in item.label">{{ label }}</div> -->
              <div class="name" @click="pdfUrl(item)">
                {{ item.title }}
              </div>
            </div>
            <div class="introduce">
              <img :src="item.thumbnail" alt="" />
              <div class="contents">
                <div class="ttitle">案例简介:</div>
                <!-- <p>{{ item.content }}</p> -->
                <div v-html="item.content"></div>
                <div style="display: flex;">
                  <div class="kind" v-for="label in item.label">{{ label }}</div>
                </div>
              </div>
            </div>
            <div class="highLight">
              <div v-if="item.highlightsList && item.highlightsList.length">案例亮点:</div>
              <div class="itemList">
                <div class="item wow animate__animated animate__zoomIn" data-wow-delay="0.5s"
                  v-for="o in item.highlightsList">
                  <img :src="o.fileUrl" alt="" />
                  <div class="imgintro">{{ o.name }}</div>
                </div>
              </div>
            </div>
            <div class="more" @click="pdfUrl(item)">
              <span>详情</span>
              <i class="el-icon-view" style="margin-left: 10px;"></i>
              <!-- <img src="../../assets/img/icon/arrow_rb.png" alt="" /> -->
            </div>
            <CareList v-if="$store.state.editStatus === 0" :data="item" @onReturn="() => { pageNum = 1; getList() }" />
          </div>
        </template>
        <EditCase v-if="$store.state.editStatus === 0" @onReturn="() => { pageNum = 1; getList() }" />
      </div>
    </div>
    <div class="pages">
      <el-pagination small layout="prev, pager, next" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <CopyRight v-if="$store.state.isMobile == 2"></CopyRight>
  </div>
</template>

<script>
import EditCase from "../models/editCase.vue"
import CareList from "../models/caseList.vue"
import SearchCase from "../components/SearchCase.vue";
import EchartsMap from "../components/EchartsMap.vue"
import EditMap from "../models/editMap.vue"
import { getClassicCaseList } from "@/api/case.js"

import { banner } from "@/api/public"
export default {
  name: "Case",
  components: {
    SearchCase,
    EchartsMap,
    EditMap,
    CareList,
    EditCase
  },
  data() {
    return {
      showCase: ["张家港", "常熟", "苏相合作区"],
      nav_list: ["全部", "测绘服务", "数据服务", "数智应用"],
      nav_btn_arr: [
        ["基础测绘", "“多测合一”跟踪服务"],
        ["自然资源综合调查", "行业专项调查", "摄影测量与遥感", "三维数据服务", "数据综合治理", "全链条数字化方案",],
        ["产业园智慧招商", "产业经济", "产业园数智管理"],
        ["智慧交通解决方案"],
        ["数字孪生安保指挥", "警情赋能分析"],
      ],
      active_index: 0,
      pageNum: 1,
      address: "",
      keywords: "",
      total: 0,
      bannerList: [],
      list: [
        {
          title: "张家港市2020-2021年大比例尺地形图航测项目航测地形图生产及建库",
          label: ['测绘服务', '大比例尺测绘', '航测'],
          Thumbnail: "case/introduce.png",
          Introduction: '为了更好地满足张家港市国土空间规划编制、自然资源“两统一”和全市域一体化建设、加强测绘地理信息公共服务和公益性保障等工作的需要，张家港市自然资源和资规局”根据《中华人民共和国测绘法》、《江苏省测绘地理信息条例》、《苏州市“十四五”基础测绘规划》和《张家港市“十四五”基础测绘规划》的要求，于2020年初，组织开展了对张家港市基础地理信息数据的生产与更新工作。<br/>项目开展前期，园测信息科技股份有限公司参与了张家港市资规局成立的课题研究组，发挥自身优势，开展了对城市基础地理信息数据生产与更新关键技术的研究，旨在通过管理创新、技术创新、成果创新和工程应用示范，形成一套行之有效的应用技术体系，并在张家港基准建设、多源数据生产与更新环节中进行应用，为张家港基础地理信息数据采集、更新、质检、管理等关节提供技术保障，也为其他城市开展同类项目建设提供借鉴。',
          highlights: [{
            img: "case/second2.png",
            name: '统一标准'
          },
          {
            img: "case/second2.png",
            name: '全数据管理'
          },
          {
            img: "case/second3.png",
            name: '智能分析'
          },
          {
            img: "case/second4.png",
            name: '智慧管网'
          }],
          url: "典型案例-基础测绘1"
        },
        {
          title: "常熟高新区地下管线普查及管线管理系统",
          label: ['管线管理系统', '地下管线普查', '测绘服务'],
          Thumbnail: "case/changshu.png",
          Introduction: '《江苏省政府办公关于加强城市地下管线建设管理的实施意见》指出：各城市要在充分整合各专业管线现有数据资料的基础上，结合普查建立地下管线综合管理信息系统，满足地下管线规划、建设、运行和应急等工作需要。综合管理信息系统和专业管线信息系统应按照统一的数据标准，实现信息共建共享、即时交换。<br/>园测信息科技股份有限公司通过先进的技术手段，普查采集常熟高新区地下管线的平面位置、高程、埋深、自流管流向、规格、材质、管线性质、权属单位以及管线附属构筑物等信息，并采集管线沿线的带状地形图。利用管线普查的空间和属性数据，建设常熟高新技术产业开发区范围内的地下管线三维模型。建设管线综合管理系统，实现城市地下管线地理空间信息数据体系的管理与应用，为城市地下空间的统一规划、合理开发和科学管理，以及地下管线安全运行、城市应急提供应用服务支撑。',
          highlights: [{
            img: "case/first.png",
            name: '张家港市“DLG+”数据标准制定'
          },
          {
            img: "case/first2.png",
            name: '新技术工艺研究与应用'
          },
          {
            img: "case/first3.png",
            name: '专利与软著'
          }],
          url: "典型案例-基础测绘"
        },
        {
          title: "苏相合作区水准测量、航测地形及管线普查",
          label: ['航测', '管线普查', '测绘服务'],
          Thumbnail: "case/introduce3.png",
          Introduction: '2020年以来，随着苏相合作区总体规划获批，开展了新一轮控规项目编制，发展建设进入2.0时代。为保证数字城市建设的顺利推进，苏州工业园区苏相合作区启动2020年苏州工业园区苏相合作区水准测量、航测地形及管线普查项目。园测信科科技股份有限公司参与完成苏相合作区范围内高程控制网布设和二等水准选点埋石工作，建立合作区高程成果管理系统，开发日常水准测量平差计算软件，以满足合作区内工程开发建设要求。在合作区全域范围开展1:500大比例尺航测地形项目，一方面是为了维护基础地理信息数据的现势性，另一方面是做为苏相合作区数字孪生城市建设的地理信息数据底座。完成苏相合作区范围内所有市政管线普查工作，地下管线探测应查明地下管线的平面位置、高程、埋深(高程)、雨水出水口、走向(流向)、规格、材质、管线性质、权属单位以及管线附属构筑物信息，并编绘以地形图为载体的地下管线图(综合管线图和专业管线图)。数据采集完成后将地下管线探测资料和基础测绘资料按照统一的数据格式标准，导入“苏相合作区管线信息系统”数据库，实现地下管线信息的制度化、科学化、规范化和标准化。',
          highlights: [{
            img: "case/third.png",
            name: '有效提高规划人员审批效率'
          },
          {
            img: "case/third2.png",
            name: '统一、精确、高效的高程基准服务'
          },
          {
            img: "case/third3.png",
            name: '支撑各类专项规划提供基础地形数据'
          }
          ],
          url: "典型案例-基础测绘2"
        },
        {
          title: "太仓市自然资源统一确权登记",
          label: ['数据服务', '自然资源登记', '地籍调查', '三维登记', '多部门协同'],
          Thumbnail: "case/szyy1.png",
          Introduction: '太仓市从2020至2022年开展自然资源统一确权登记工作，建设内容主要包含确定自然资源登记范围，预划登记单元；开展地籍调查，划清登记单元线内的“四条边界”；开展地籍调查成果数据上图入库，协助完成登簿；探索水流三维登记共4项内容。在太仓市自然资源和规划局的领导下，多个行政部门、街道政府共同参与全市自然资源统一确权登记工作，保障登记工作顺利完成，成果合格并完成汇交。',
          highlights: [],
          url: "典型案例-数据服务"
        },
        {
          title: "无锡市惠山区第一次全国自然灾害综合风险普查（房屋建筑）",
          label: ['数据服务', '房屋安全', '风险评估'],
          Thumbnail: "case/tp1.jpg",
          Introduction: '无锡市惠山区为了摸清全区房屋建筑底数，建立反映承灾体数量、空间分布与设防水平的调查成果库，调查区域内城镇房屋建筑和农村房屋建筑，满足第一次全国自然灾害综合风险普查对房屋建筑承灾体信息需求，支撑自然灾害综合风险与减灾能力评估。',
          highlights: [],
          url: "无锡市惠山区第一次全国自然灾害综合风险普查"
        },
        {
          title: "苏州市自然资源及规划数据治理",
          label: ['数据服务', '城区整合', '市域汇聚'],
          Thumbnail: "case/tp2.png",
          Introduction: '针对自然资源数据建设需求及数据现状分析，梳理出一套自然资源数据从汇聚、整合、管理到应用的动态化数据治理机制，具体治理流程为：前期需求调研、数据目录体系建设、数据资源收集分析、数据预处理、数据坐标转换、数据标准化整合、数据建库、服务发布与共享、数据联动更新以及数据汇交等环节。',
          highlights: [],
          url: "苏州市自然资源及规划数据治理"
        },
        {
          title: "太仓市沙溪镇集成指挥中心",
          label: ['数智应用', '党建引领', '指挥调度', '网格管理'],
          Thumbnail: "case/sz1.png",
          Introduction: '沙溪镇集成指挥中心实现了各部门地理、人口、法人数据资源的汇集整合，通过专项整治管理、监控联动管理、远程指挥决策建设，构建了集成指挥决策体系，提高了沙溪镇综合治理和应急指挥能力。同时发挥信息化应用价值，不断激发数字服务新活力，为推动新征程上沙溪镇各项工作跃上新台阶提供数据支撑。',
          highlights: [{
            name: '开创了智慧城市在镇级行政区域建设的先河',
            img: "case/szf1.png"
          },
          {
            name: '提高基层治理能力',
            img: "case/szf2.png"
          },
          {
            name: '多领域应用',
            img: "case/szf3.png"
          }],
          url: "典型案例-数智应用1"
        },
        {
          title: "苏州工业园区智慧警务全数字防线实战赋能应用系统",
          label: ['数智应用', '智慧警务', '红蓝对抗', '网格管理'],
          Thumbnail: "case/sz2.png",
          Introduction: '全数字防线实战赋能应用系统充分融合园区警务全要素资源，形成实战数据资源库。基于园区三维地图，实现实战资源监控设备、警力部署等重点资源等的可视化分析，构建警务实战资源库。充分利用时空分析、图像识别、大数据分析等技术，实现人、车的快速发现与追踪，为实战对抗提供指挥决策支撑。基于园区三维地图，实现红蓝对抗演练中一图协同攻防，打造警务时空信息可视化指挥系统。最终集中园区优势数据、信息化资源，实现重点人、车对象的快速发现、追踪、围捕，精准打击违法活动。',
          highlights: [{
            name: '多维布控与预警=',
            img: "case/szt1.png"
          },
          {
            name: '融合搜索',
            img: "case/szt2.png"
          },
          {
            name: '时空分析',
            img: "case/szt3.png"
          }],
          url: "典型案例-数智应用2"
        },
        {
          title: "苏州市文物保护建筑三维建模",
          label: ['数据服务', '历史文物保护', '建筑物测绘'],
          Thumbnail: "case/tp3.png",
          Introduction: '为了弘扬中华优秀传统文化，延续城市历史文脉，保留中华文化基因的城市建设理念，全面摸清全区历史建筑现状，为管理部门制定长效管理机制提供详实信息资料，建设历史建筑保护利用新模式、新机制提供支持，苏州市利用三维激光扫描仪、无人机等先进的测绘技术手段对文物保护单元展开现状影像采集、全景采集、文物信息采集、三维建模和地形图、平立剖的绘制工作。',
          highlights: [],
          url: "苏州市自然资源及规划数据治理"
        },
        {
          title: "苏州工业园区智能中枢-数据中台",
          label: ['数据服务', '数据汇聚', '数据治理', '共享交换', '开发分析'],
          Thumbnail: "case/znsg.png",
          Introduction: '数据中台包括数据汇聚能力、数据治理能力和数据开发能力。数据汇聚能力提供区域各委办部门政务数据汇聚提供高速稳定的通道；数据治理和开发能力为各委办单位提供多租户空间，基于数据标准和开发规范，自行进行数据处理和数据开发分析工作。',
          highlights: [],
          url: "苏州工业园区智能中枢-数据中台"
        },
        {
          title: "苏州工业园区第一次全国自然灾害综合风险普查",
          label: ['数据服务', '综合实施', '广泛应用'],
          Thumbnail: "case/znsg.png",
          Introduction: '苏州工业园区从2021至2022年开展自然灾害综合风险普查工作，建设内容主要包含致灾因子调查、承灾体调查、历史灾害灾情调查、综合减灾能力调查、重点隐患调查、风险评估区划等6项内容。在苏州工业园区管委会的领导下，多个行政部门、街道政府、基层组织与广大市民共同参与全区各项普查工作，保障普查工作顺利完成，成果合格并完成汇交。',
          highlights: [],
          url: "苏州工业园区第一次全国自然灾害综合风险普查"
        },
        {
          title: "苏州工业园区城市国土空间监测",
          label: ['数据服务', '综合实施', '广泛应用'],
          Thumbnail: "case/znsg.png",
          Introduction: '苏州工业园区以2022年度国土变更调查成果为底图，依据2023年高分辨率遥感影像和最新的相关专题资料，结合实地调查等工作，在园区组织开展城市国土空间监测工作，掌握城市建设总量、用地结构、基础设施和服务功能等情况，支撑城市建设用地细化、国土空间规划编制及实施监督、城市体检评估和用途管制等国土空间治理工作。',
          highlights: [],
          url: "苏州工业园区城市国土空间监测"
        },
        {
          title: "苏州工业园区CIM平台",
          label: ['数据服务', '综合实施', '广泛应用'],
          Thumbnail: "case/znsg.png",
          Introduction: '苏州工业园区CIM平台结合国土空间规划、工程项目审批制度改革，聚焦重点项目全过程管理、地籍管理等业务需求，整合与提升城市公共信息服务平台能力，对接规划管理信息系统、不动产权籍系统等，作为二三维一体化的园区空间资源信息枢纽，服务于园区空间资源应用需求相应委办局，辅助政务人员日常工作。',
          highlights: [{
            img: "case/first.png",
            name: '提高资源管控能力'
          },
          {
            img: "case/first2.png",
            name: '提高数据服务能力'
          },
          {
            img: "case/first3.png",
            name: '提高智能应用能力'
          }],
          url: "苏州工业园区CIM平台"
        },
      ],
      showlist: [],
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    this.$wow.init();
    banner({ isRelease: this.$store.state.editStatus, type: 3 }).then(res => {
      this.bannerList = res.data;
    })
    this.getList();
  },
  methods: {
    bannerDate() { },
    getList() {
      getClassicCaseList({
        "address": this.address,
        "isRelease": this.$store.state.editStatus,
        "keywords": this.keywords,
        "pageNum": this.pageNum,
        "pageSize": 10
      }).then(res => {
        this.total = res.data.total;
        this.showlist = [];
        res.data.list.forEach(e => {
          e.label = e.label.split(';')
          this.showlist.push(e)
          if (e.labelMore) {
            let arr = e.labelMore.split(';');
            e.label = e.label.concat(arr).filter(val => {
              // 去除空字符串''
              return val && val.trim()
            })
          }
        })

      })
    },
    onCloseMap(val) {
      this.$refs.EchartsMap.init(val)
    },
    pdfUrl(item) {
      // let d = new Date()
      // this.$router.push({ path: '/pdfFile', query: { name: item.fileUrl, url: '', type: 4, t: d.getTime() } })
      this.$router.push({
        path: '/caseMod',
        query: {
          CaseId: item.id
        }
      })
    },
    searchData(val) {
      this.keywords = val.keywords;
      this.address = val.address;
      this.pageNum = 1;
      this.getList()
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.showlist = [];
      this.getList()
      scrollTo(0, 100)
    },
    onNavList(index, name) {
      this.active_index = index;
      this.keywords = name === '全部' ? '' : name;
      this.pageNum = 1;
      this.getList();
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 60px;

  >div {
    width: 100%;
    background-size: cover;
    overflow: hidden;
  }
}

.top_native {
  width: 100%;
  background: url("../../assets/img/map.png") no-repeat center;
  background-position: 0 -140px;
  background-size: cover;
  text-align: left;
  position: relative;
  height: 500px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .map {
    position: absolute;
    top: 0;
    right: 100px;
    z-index: 1;
  }

  .caseTitle {
    font-family: Source Han Sans CN;
    font-size: 60px;
    font-weight: bold;
    position: absolute;
    top: 150px;
    left: 120px;

    .chinese {
      color: #003988;
    }

    .engli {
      font-size: 50px;
      padding: 10px 30px;
      background: #003988;
      color: #cbe3fe;
      font-style: italic;
    }
  }
}



.mainCon {
  position: relative;

  // top: -70px;
  .navBar {
    width: 100vw;
    display: flex;
    height: 100px;
    background-color: #f5f5f5;

    .search {
      // background-color: #f5f5f5;
      height: 100%;
      width: 30%;
      // position: absolute;
      // bottom: 0;
      display: flex;
      justify-content: center;
      margin-left: auto;
    }

    .nav_arr {
      display: flex;
      margin-left: 160px;

      .menuItem {
        cursor: pointer;
        font-size: 24px;
        font-family: Source Han Sans CN;
        line-height: 67px;
        color: #b5b5b5;
        margin: auto 0;
        margin-right: 100px;
        display: flex;

        span {
          display: block;
          color: #00398a;
          margin-right: 5px;
          font-weight: 700;
        }
      }

      .active {
        span {
          color: #d7000f;
          font-weight: 600;
          border-bottom: 3px solid #d7000f;
        }
      }
    }
  }

  .cards {
    position: relative;
    min-height: 100px;
    padding-bottom: 20px;
  }

  .card {
    margin: 0 auto;
    padding: 20px;
    width: 1600px;
    margin-top: 80px;
    background: #ffffff;
    box-shadow: 5px 5px 12px 0px rgba(204, 196, 196, 0.24);
    // z-index: 80;
    z-index: 1;
    position: relative;

    .topTit {
      display: flex;
      line-height: 42px;
      font-family: Source Han Sans CN;

      .name {
        font-size: 24px;
        font-weight: 600;
        color: #00398a;
        cursor: pointer;
      }

      // .kind {
      //   background: #ffffff;
      //   border: 1px solid #00398a;
      //   border-radius: 2px;
      //   margin: 0 20px;
      //   padding: 0 20px;
      //   font-size: 16px;
      //   font-weight: 400;
      //   color: #00398a;
      // }
    }

    .introduce {
      display: flex;
      font-family: Source Han Sans CN;
      margin-top: 10px;

      img {
        width: 530px;
        height: 270px;
      }

      .contents {
        width: calc(100% - 530px);

        .kind {
          background: #ffffff;
          border: 1px solid #00398a;
          border-radius: 2px;
          margin: 0 20px;
          padding: 0 20px;
          font-size: 16px;
          font-weight: 400;
          color: #00398a;
          margin-top: 20px;
        }

        .ttitle {
          color: #666;
          font-weight: 600;
          font-size: 16px;
        }

        p {
          color: #828894;
        }

        margin-left: 20px;
        text-align: left;
        line-height: 34px;
      }
    }

    .highLight {
      display: flex;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 600;
      color: #828894;

      .itemList {
        margin-top: 40px;
        width: 90%;
        display: flex;
        justify-content: space-between;
      }

      .item {
        img {
          transition: transform 0.5s;
        }

        img:hover {
          transform: scale(1.2);
        }

        .imgintro {
          height: 16px;
          font-size: 16px;
          font-weight: 400;
          color: #828894;
          line-height: 25px;
        }
      }
    }

    .more {
      cursor: pointer;
      text-align: right;
      // font-size: 16px;
      font-size: 18px;
      font-weight: 900;
      color: #00398a;
      line-height: 25px;
      margin: 30px 20px 10px 0;

      img {
        position: relative;
        top: 15px;
        left: 5px;
        width: 17px;
      }
    }
  }

  .flexRight {
    justify-content: right;
  }
}

.el-pagination {
  text-align: center;
  margin-top: 50px;
}
</style>
